// src/layout/admin/MasterLayout.jsx
import React, { useState, useEffect , useContext} from "react";
import { Row, Col } from "react-bootstrap";
import AdminSidebar from "../../components/superadmin/sidebar/SideBar";
import TopNavbar from "../../components/superadmin/topnavbar/TopNavbar";
import '../../assets/css/superadmin/masterlayout/MasterLayout.css';
import AppContext from "../../context/AppContext";


const MasterLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const {setAuthToken, setLoggedInAdmin} = useContext(AppContext);

  // Check if screen is mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false); // Reset sidebar state on desktop
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  useEffect(()=>{
    const authToken = localStorage.getItem("authToken");
    setAuthToken(authToken); 

    const savedAdmin = JSON.parse(localStorage.getItem("LoggedInAdmin"));
    setLoggedInAdmin(savedAdmin);
    
  } ,[]);

  return (
    <div className="admin-master-layout">
      <Row className="g-0">
        {/* Sidebar Column - Hidden on mobile, shown via overlay */}
        <Col lg={3} md={4} className={`sidebar-col ${isMobile ? 'd-none' : ''}`}>
          <AdminSidebar isOpen={false} onClose={closeSidebar} />
        </Col>

        {/* Mobile Sidebar - Shown as overlay */}
        {isMobile && (
          <AdminSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        )}

        {/* Content Column */}
        <Col lg={9} md={8} sm={12} className="content-col">
          <TopNavbar 
            onToggleSidebar={toggleSidebar} 
            isSidebarOpen={isSidebarOpen}
          />
          <div className="admin-content-wrapper">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MasterLayout;